import React, { useState } from 'react';
import { getApiBaseUrl } from '../config';
import { useTranslation } from '../i18n/LanguageContext';

// Schadens- und Verlustmeldung (öffentlich). Foto der Gepäckmarke ist Pflicht, Meldung
// nur am selben Tag (Ausnahme-Link der Leitung: ?k=…). Texte bewusst nur DE/EN –
// alle anderen Sprachen bekommen Englisch.
const TXT = {
  de: {
    title: 'Schaden oder Verlust melden',
    intro: 'Ihr Gepäckstück wurde beschädigt oder ist nicht auffindbar? Bitte melden Sie es hier noch am selben Tag – mit Foto der Gepäckmarke. Wir prüfen die Meldung und melden uns bei Ihnen.',
    damaged: 'Gepäckstück beschädigt', lost: 'Gepäckstück nicht auffindbar',
    tagNumber: 'Nummer der Gepäckmarke', station: 'Station', stationPick: 'bitte wählen', unknown: 'weiß ich nicht',
    dropoff: 'Tag der Abgabe', event: { damaged: 'Tag der Abholung', lost: 'Tag, an dem es fehlte' },
    reported: 'Haben Sie es schon direkt an der Station gemeldet?', yes: 'Ja', no: 'Nein',
    itemType: 'Art des Gepäckstücks', itemTypes: { rucksack: 'Rucksack', tasche: 'Tasche', kinderwagen: 'Kinderwagen', koffer: 'Koffer', sonstiges: 'Sonstiges' },
    item: 'Beschreibung des Gepäckstücks', itemPh: 'Farbe, Marke, Größe – z. B. schwarz, Deuter, ca. 30 Liter',
    bank: 'Bankverbindung für eine mögliche Erstattung', iban: 'IBAN', holder: 'Kontoinhaber', noIban: 'Ich habe kein IBAN-Konto (z. B. Konto außerhalb Europas)',
    bankHint: 'Falls wir den Schaden erstatten, überweisen wir direkt auf dieses Konto. Die Angabe ist keine Zusage einer Zahlung.', needType: 'Bitte die Art des Gepäckstücks wählen.',
    damage: 'Was ist beschädigt?', damagePh: 'z. B. Reißverschluss ausgerissen, Rolle abgebrochen …',
    contents: 'Wesentlicher Inhalt', contentsPh: 'Was war drin? Je genauer, desto eher finden wir es.', contentsOpt: 'Inhalt (optional)',
    value: 'Geschätzter Zeitwert in € (optional)',
    tagPhoto: 'Foto der Gepäckmarke / des Abholscheins (Pflicht)', photos: { damaged: 'Fotos vom Schaden (mind. 1, max. 5)', lost: 'Foto des Gepäckstücks, falls vorhanden (max. 5)' },
    receipt: 'Kaufbeleg (optional)',
    name: 'Vor- und Nachname', email: 'E-Mail', phone: 'Telefon (mit Ländervorwahl)',
    consent: 'Ich bin einverstanden, dass meine Angaben und Fotos zur Bearbeitung dieser Meldung gespeichert werden.',
    legal: 'Es gelten unsere AGB: Wir haften bis zum Zeitwert, insgesamt höchstens 100 € je Gepäckstück – einschließlich Inhalt. Wertgegenstände im Gepäck (z. B. Handy, Laptop, Bargeld, Schmuck) werden nicht zusätzlich ersetzt, ihre Aufbewahrung erfolgt auf eigene Gefahr. Die Meldung ist keine Anerkennung eines Anspruchs.',
    submit: 'Meldung absenden', sending: 'Wird gesendet …', cancel: 'Abbrechen',
    okTitle: 'Ihre Meldung ist eingegangen', okText: 'Referenz', okMail: 'Eine Bestätigung geht an', okNext: 'Wir prüfen die Meldung und melden uns so schnell wie möglich bei Ihnen.',
    needTag: 'Bitte ein Foto der Gepäckmarke hinzufügen.', needPhoto: 'Bitte mindestens ein Foto vom Schaden hinzufügen.',
    open: 'Gepäck beschädigt oder nicht auffindbar? Hier melden',
  },
  en: {
    title: 'Report damage or loss',
    intro: 'Your item was damaged or cannot be found? Please report it here on the same day – with a photo of your luggage tag. We will review your report and get back to you.',
    damaged: 'Item damaged', lost: 'Item cannot be found',
    tagNumber: 'Luggage tag number', station: 'Station', stationPick: 'please choose', unknown: "I don't know",
    dropoff: 'Drop-off date', event: { damaged: 'Pick-up date', lost: 'Date it was missing' },
    reported: 'Did you already report it at the station?', yes: 'Yes', no: 'No',
    itemType: 'Type of item', itemTypes: { rucksack: 'Backpack', tasche: 'Bag', kinderwagen: 'Stroller / pram', koffer: 'Suitcase', sonstiges: 'Other' },
    item: 'Description of the item', itemPh: 'Colour, brand, size – e.g. black, Deuter, approx. 30 litres',
    bank: 'Bank details for a possible refund', iban: 'IBAN', holder: 'Account holder', noIban: 'I do not have an IBAN account (e.g. bank account outside Europe)',
    bankHint: 'If we refund the damage, we will transfer the amount directly to this account. Providing it is not a promise of payment.', needType: 'Please choose the type of item.',
    damage: 'What is damaged?', damagePh: 'e.g. zip torn, wheel broken off …',
    contents: 'Main contents', contentsPh: 'What was inside? The more precise, the better we can find it.', contentsOpt: 'Contents (optional)',
    value: 'Estimated current value in € (optional)',
    tagPhoto: 'Photo of the luggage tag / claim ticket (required)', photos: { damaged: 'Photos of the damage (at least 1, max. 5)', lost: 'Photo of the item, if available (max. 5)' },
    receipt: 'Receipt (optional)',
    name: 'First and last name', email: 'E-mail', phone: 'Phone (with country code)',
    consent: 'I agree that my details and photos are stored to process this report.',
    legal: 'Our terms and conditions apply: we are liable up to the current value, with an overall maximum of €100 per item – including its contents. Valuables inside (e.g. phone, laptop, cash, jewellery) are not compensated on top; they are stored at your own risk. This report is not an acknowledgement of a claim.',
    submit: 'Send report', sending: 'Sending …', cancel: 'Cancel',
    okTitle: 'Your report has been received', okText: 'Reference', okMail: 'A confirmation will be sent to', okNext: 'We will review your report and get back to you as soon as possible.',
    needTag: 'Please add a photo of the luggage tag.', needPhoto: 'Please add at least one photo of the damage.',
    open: 'Item damaged or cannot be found? Report it here',
  },
};

// Wiesn-Tag in Münchner Zeit (bis 03:00 zählt der Vortag) – muss zur Backend-Regel passen
const wiesnToday = () => {
  const b = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
  b.setHours(b.getHours() - 3);
  return `${b.getFullYear()}-${String(b.getMonth() + 1).padStart(2, '0')}-${String(b.getDate()).padStart(2, '0')}`;
};

export const claimOpenLabel = (language) => (['de', 'bar'].includes(language) ? TXT.de.open : TXT.en.open);

const LuggageClaim = ({ initialTag = '', initialStation = '', onClose }) => {
  const { language } = useTranslation();
  const T = ['de', 'bar'].includes(language) ? TXT.de : TXT.en;
  const lateKey = new URLSearchParams(window.location.search).get('k') || '';
  const today = wiesnToday();
  const [f, setF] = useState({
    type: 'damaged', tagNumber: initialTag, station: initialStation, dropoffDate: today, eventDate: today, reportedAtStation: '',
    itemType: '', iban: '', accountHolder: '', noIban: false,
    itemDescription: '', damageDescription: '', contents: '', estimatedValue: '', name: '', email: '', phone: '', consent: false, website: '',
  });
  const [tagPhoto, setTagPhoto] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [receipt, setReceipt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!f.itemType) return setError(T.needType);
    if (!tagPhoto) return setError(T.needTag);
    if (f.type === 'damaged' && !photos.length) return setError(T.needPhoto);
    setBusy(true);
    try {
      const fd = new FormData();
      Object.entries(f).forEach(([k, v]) => fd.append(k, typeof v === 'boolean' ? (v ? '1' : '') : v));
      if (lateKey) fd.append('k', lateKey);
      fd.append('tagPhoto', tagPhoto);
      photos.slice(0, 5).forEach((p) => fd.append('photos', p));
      if (receipt) fd.append('receipt', receipt);
      const res = await fetch(`${getApiBaseUrl()}/luggage-claim`, { method: 'POST', body: fd });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(body.error || 'Fehler');
      setDone({ id: body.id, email: f.email });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) { setError(err.message); }
    setBusy(false);
  };

  if (done) {
    return (
      <div className="card shadow-lg border-0 mb-4" style={{ borderLeft: '6px solid #28a745' }}>
        <div className="card-body p-4 text-center">
          <div style={{ fontSize: '2.5rem' }} className="mb-2">✅</div>
          <h5 className="fw-bold mb-2">{T.okTitle}</h5>
          <p className="mb-1">{T.okText}: <strong>#S{done.id}</strong></p>
          <p className="text-muted small mb-2">{T.okMail} <strong>{done.email}</strong></p>
          <p className="mb-0">{T.okNext}</p>
        </div>
      </div>
    );
  }

  const fileInput = (label, onChange, opts = {}) => (
    <div className="mb-3">
      <label className="form-label fw-semibold">{label}</label>
      <input type="file" className="form-control" accept="image/*,.pdf" capture={opts.capture ? 'environment' : undefined} multiple={!!opts.multiple} onChange={onChange} />
    </div>
  );

  return (
    <div className="card shadow-lg border-0 mb-4">
      <div className="card-body p-4">
        <h4 className="fw-bold mb-2">🧳 {T.title}</h4>
        <p className="text-muted">{T.intro}</p>
        <form onSubmit={submit} noValidate>
          <div className="btn-group w-100 mb-3" role="group">
            {['damaged', 'lost'].map((k) => (
              <button key={k} type="button" className={`btn ${f.type === k ? 'btn-warning' : 'btn-outline-secondary'}`} onClick={() => setF({ ...f, type: k })}>{T[k]}</button>
            ))}
          </div>

          <div className="row g-3 mb-3">
            <div className="col-6"><label className="form-label fw-semibold">{T.tagNumber}</label>
              <input className="form-control" inputMode="numeric" value={f.tagNumber} onChange={set('tagNumber')} required /></div>
            <div className="col-6"><label className="form-label fw-semibold">{T.station}</label>
              <select className="form-select" value={f.station} onChange={set('station')}>
                <option value="">{T.stationPick}</option>
                {['G1', 'G5', 'G8', 'G10'].map((s) => <option key={s} value={s}>{s} – P{s.slice(1)}</option>)}
                <option value="?">{T.unknown}</option>
              </select></div>
            <div className="col-6"><label className="form-label fw-semibold">{T.dropoff}</label>
              <input type="date" className="form-control" value={f.dropoffDate} max={today} onChange={set('dropoffDate')} /></div>
            <div className="col-6"><label className="form-label fw-semibold">{T.event[f.type]}</label>
              <input type="date" className="form-control" value={f.eventDate} max={today} onChange={set('eventDate')} required /></div>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold d-block">{T.reported}</label>
            {['yes', 'no'].map((v) => (
              <div className="form-check form-check-inline" key={v}>
                <input className="form-check-input" type="radio" id={`rep-${v}`} checked={f.reportedAtStation === v} onChange={() => setF({ ...f, reportedAtStation: v })} />
                <label className="form-check-label" htmlFor={`rep-${v}`}>{T[v]}</label>
              </div>
            ))}
          </div>

          <div className="mb-3"><label className="form-label fw-semibold">{T.itemType}</label>
            <div className="d-flex flex-wrap gap-2">
              {Object.entries(T.itemTypes).map(([k, label]) => (
                <button key={k} type="button" className={`btn btn-sm ${f.itemType === k ? 'btn-dark' : 'btn-outline-secondary'}`} onClick={() => setF({ ...f, itemType: k })}>{label}</button>
              ))}
            </div></div>
          <div className="mb-3"><label className="form-label fw-semibold">{T.item}</label>
            <textarea className="form-control" rows={2} placeholder={T.itemPh} value={f.itemDescription} onChange={set('itemDescription')} required /></div>
          {f.type === 'damaged' && (
            <div className="mb-3"><label className="form-label fw-semibold">{T.damage}</label>
              <textarea className="form-control" rows={2} placeholder={T.damagePh} value={f.damageDescription} onChange={set('damageDescription')} required /></div>
          )}
          <div className="mb-3"><label className="form-label fw-semibold">{f.type === 'lost' ? T.contents : T.contentsOpt}</label>
            <textarea className="form-control" rows={2} placeholder={T.contentsPh} value={f.contents} onChange={set('contents')} required={f.type === 'lost'} /></div>
          <div className="mb-3"><label className="form-label fw-semibold">{T.value}</label>
            <input className="form-control" inputMode="decimal" value={f.estimatedValue} onChange={set('estimatedValue')} style={{ maxWidth: 180 }} /></div>

          {fileInput(T.tagPhoto, (e) => setTagPhoto(e.target.files[0] || null))}
          {fileInput(T.photos[f.type], (e) => setPhotos(Array.from(e.target.files || []).slice(0, 5)), { multiple: true })}
          {f.type === 'damaged' && fileInput(T.receipt, (e) => setReceipt(e.target.files[0] || null))}

          <div className="row g-3 mb-3">
            <div className="col-12"><label className="form-label fw-semibold">{T.name}</label>
              <input className="form-control" autoComplete="name" value={f.name} onChange={set('name')} required /></div>
            <div className="col-md-6"><label className="form-label fw-semibold">{T.email}</label>
              <input type="email" className="form-control" autoComplete="email" value={f.email} onChange={set('email')} required /></div>
            <div className="col-md-6"><label className="form-label fw-semibold">{T.phone}</label>
              <input type="tel" className="form-control" autoComplete="tel" value={f.phone} onChange={set('phone')} required /></div>
          </div>

          <div className="border rounded p-3 mb-3 bg-light">
            <div className="fw-semibold mb-2">💶 {T.bank}</div>
            {!f.noIban && (
              <div className="row g-2 mb-2">
                <div className="col-md-7"><label className="form-label small mb-0">{T.iban}</label>
                  <input className="form-control" autoComplete="off" placeholder="DE00 0000 0000 0000 0000 00" value={f.iban} onChange={set('iban')} style={{ textTransform: 'uppercase' }} /></div>
                <div className="col-md-5"><label className="form-label small mb-0">{T.holder}</label>
                  <input className="form-control" autoComplete="off" value={f.accountHolder} onChange={set('accountHolder')} /></div>
              </div>
            )}
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="claim-noiban" checked={f.noIban} onChange={set('noIban')} />
              <label className="form-check-label small" htmlFor="claim-noiban">{T.noIban}</label>
            </div>
            <div className="small text-muted mt-1">{T.bankHint}</div>
          </div>

          <input type="text" name="website" value={f.website} onChange={set('website')} tabIndex={-1} autoComplete="off" style={{ position: 'absolute', left: '-9999px' }} aria-hidden="true" />

          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" id="claim-consent" checked={f.consent} onChange={set('consent')} />
            <label className="form-check-label small" htmlFor="claim-consent">{T.consent}</label>
          </div>
          <p className="small text-muted">{T.legal}</p>
          {error && <div className="alert alert-danger py-2">{error}</div>}
          <div className="d-grid gap-2">
            <button className="btn btn-warning btn-lg" disabled={busy || !f.consent}>{busy ? T.sending : T.submit}</button>
            {onClose && <button type="button" className="btn btn-link" onClick={onClose}>{T.cancel}</button>}
          </div>
        </form>
      </div>
    </div>
  );
};

export default LuggageClaim;
